let clientId = '';
let clientSecret = '';

const mode = process.env.NODE_ENV;
if (mode === 'production') {
  clientId = process.env.VUE_APP_CLIENT_ID_PROD
  clientSecret = process.env.VUE_APP_CLIENT_SECRET_PROD
}
if (mode === 'development') {
  clientId = process.env.VUE_APP_CLIENT_ID_DEV
  clientSecret = process.env.VUE_APP_CLIENT_SECRET_DEV
}

export const API = {
  baseUrl: 'https://api.thiriez-literie.fr',
  clientId: clientId,
  clientSecret: clientSecret,
}

export const ENDPOINTS = {
  login: "/auth/token?grant_type=password&",
  userAccount: "/auth?call=v2",
  b2b: '/b2b',
  gpao: '/gpao',
  otl: '/otl'
}

export const HEADERS = {
  createUser: { 'API': 'CREAT_USER' },
  updateUser: { 'API': 'EDIT_USER' },
  epanier: 'EPANIER',
  lpanier: 'LPANIER',
  spanier: 'SPANIER',
  vpanier: 'VPANIER',
  readUser: { 'API': 'READ_USER' },
  forgotPassword: { 'API': 'FORGOT_PASSWORD' },
  b2b: 'LISTEARTICLE',
  contacts: 'CONTACTS_COMMERCE',
  datesFermees: "DATES",
  deliveryAddress: 'CLIENT_ADR_LIVRAISON',
  divers: "CONSTANTES",
  downloadDocV2 : "GEDV2_DOWNLOAD_FILE",
  ficDocDl: 'FIC_DOC_DL',
  ficDocListe: 'FIC_DOC_LISTE',
  gedListe: 'GED_DOC_LISTE',
  gedV2DocListe: 'GEDV2_DOC_LISTE',
  gedDocDl: 'GED_DOC_DL',
  gedDocInfo: 'GED_DOC_JSON',
  gpaoEstimerDelai: 'ESTIMERDELAI',
  otlEmail: 'EMAIL',
  //contacts: 'CONTACTS',
  sav: "SAV",
  searchProduct: 'POURJEJE'
}